// frontend\src\pages\Register.js
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GET_REGISTER_API } from "../constants";
import axios from "axios";
import { toast } from "react-toastify";
import ScrollToTopButton from "../components/ScrollToTopButton";

function Register() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    password2: "",
    email: "",
    first_name: "",
    last_name: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // Очищаем ошибки при изменении поля
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ""
      });
    }
  };

  const validate = () => {
    const newErrors = {};
    
    if (formData.password !== formData.password2) {
      newErrors.password2 = "Пароли не совпадают";
    }
    
    if (formData.password.length < 8) {
      newErrors.password = "Пароль должен содержать минимум 8 символов";
    }
    
    if (!formData.email.includes('@')) {
      newErrors.email = "Введите корректный email адрес";
    }
    
    if (formData.username.length < 3) {
      newErrors.username = "Имя пользователя должно содержать минимум 3 символа";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    setErrors({}); // Очищаем предыдущие ошибки

    try {
      await axios.post(`/api${GET_REGISTER_API}`, formData);
      toast.success("Регистрация прошла успешно!");
      navigate("/login");
    } catch (err) {
      console.log("Ошибка регистрации:", err.response?.data);
      
      // Обрабатываем ошибки с бэкенда
      if (err.response?.data) {
        const backendErrors = err.response.data;
        
        // Обрабатываем ошибки пароля
        if (backendErrors.password) {
          setErrors({ 
            password: Array.isArray(backendErrors.password) 
              ? backendErrors.password.join(', ') 
              : backendErrors.password 
          });
        }
        
        // Обрабатываем ошибки подтверждения пароля
        if (backendErrors.password2) {
          setErrors(prev => ({ 
            ...prev, 
            password2: Array.isArray(backendErrors.password2) 
              ? backendErrors.password2.join(', ') 
              : backendErrors.password2 
          }));
        }
        
        // Обрабатываем другие ошибки
        if (backendErrors.username) {
          setErrors(prev => ({ 
            ...prev, 
            username: Array.isArray(backendErrors.username) 
              ? backendErrors.username.join(', ') 
              : backendErrors.username 
          }));
        }
        
        if (backendErrors.email) {
          setErrors(prev => ({ 
            ...prev, 
            email: Array.isArray(backendErrors.email) 
              ? backendErrors.email.join(', ') 
              : backendErrors.email 
          }));
        }
        
        // Показываем общую ошибку, если нет конкретных
        if (!backendErrors.password && !backendErrors.password2 && !backendErrors.username && !backendErrors.email) {
          toast.error(err.response?.data?.detail || "Ошибка регистрации");
        }
      } else {
        toast.error("Ошибка соединения с сервером");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-8 col-lg-6">
          <div className="card shadow">
            <div className="card-body">
              <h2 className="card-title text-center mb-4">Регистрация</h2>
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="first_name" className="form-label">
                      Имя
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.first_name ? "is-invalid" : ""}`}
                      id="first_name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                    />
                    {errors.first_name && (
                      <div className="invalid-feedback">{errors.first_name}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="last_name" className="form-label">
                      Фамилия
                    </label>
                    <input
                      type="text"
                      className={`form-control ${errors.last_name ? "is-invalid" : ""}`}
                      id="last_name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      required
                    />
                    {errors.last_name && (
                      <div className="invalid-feedback">{errors.last_name}</div>
                    )}
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && (
                    <div className="invalid-feedback">{errors.email}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label htmlFor="username" className="form-label">
                    Имя пользователя
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.username ? "is-invalid" : ""}`}
                    id="username"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                  />
                  {errors.username && (
                    <div className="invalid-feedback">{errors.username}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Пароль
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  {errors.password && (
                    <div className="invalid-feedback">{errors.password}</div>
                  )}
                  <div className="form-text">
                    Пароль должен содержать минимум 8 символов, включать буквы и цифры
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="password2" className="form-label">
                    Подтвердите пароль
                  </label>
                  <input
                    type="password"
                    className={`form-control ${errors.password2 ? "is-invalid" : ""}`}
                    id="password2"
                    name="password2"
                    value={formData.password2}
                    onChange={handleChange}
                    required
                  />
                  {errors.password2 && (
                    <div className="invalid-feedback">{errors.password2}</div>
                  )}
                </div>

                <div className="d-grid gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          aria-hidden="true"
                        ></span>
                        Регистрация...
                      </>
                    ) : (
                      "Зарегистрироваться"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ScrollToTopButton/>
    </div>
  );
}

export default Register;